
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { CommonModule } from '@angular/common';
import { IndexComponent } from './views/admin/components/index/index.component';





const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        redirectTo:"admin/indice",
        pathMatch:"full"
      },
      {
        path: 'indice',
        component: IndexComponent,

        },
      {
        path: 'admin',
        component: AdminLayoutComponent,
        loadChildren: () =>
          import('./views/admin/admin.module').then((m) => m.AdminModule),
        },



    ],
  },
];


@NgModule({
  imports: [CommonModule,
    RouterModule.forRoot(routes, {
      anchorScrolling: 'enabled',
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
